import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { OrderedMap } from "immutable";

import { api } from "../../../api/api";
import { featureSagaCreator } from "../../../utils/featureSagaCreator";
import {blockProductsLoaded, housesLoading, housesLoaded, manufacturesLoaded, streetsLoaded, vacanciesLoaded} from "./catalogAction";
import { LOAD_HOUSES } from "./catalogConstants";
import { generateCalls } from "../../../utils/utils";
import { feedbackTroublesLoaded } from "../../order/feedbackForm/_core/feedackTroublesActions";
import { LOAD_FEEDBACK_TROUBLES } from "../../order/feedbackForm/_core/feedackTroublesConstants";


function* loadStreets()
{
  const { result } = yield call(api.address.streets);
  yield put(streetsLoaded(result))
}

function* loadVacancies()
{
  const { result } = yield call(api.system.vacancies);
  yield put(vacanciesLoaded(result))
}

function* loadBlockProducts()
{
    const { result } = yield call(api.system.blockProducts);
    yield put(blockProductsLoaded(result))
}

function* loadHouses({payload}) {
    yield put(housesLoading());
    let lastError = null;
    for (let attempt = 1; attempt <= 3; attempt++) {
        try {
            const {result, error} = yield call(api.address.houses, payload);
            if (error) {
                lastError = error;
                throw new Error(error);
            }
            yield put(housesLoaded(result));
            return;
        } catch (error) {
            console.log(`Попытка ${attempt} из 3 не удалась:`, error);

            if (attempt < 3) {
                const delayTime = 1000 * Math.pow(2, attempt - 1);
                yield delay(delayTime);
            }
        }
    }

    yield delay(2000);
    alert('Не удалось загрузить список домов.')
    window.location.reload();
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function* loadManufactures()
{
  const { result } = yield call(api.manufactures.manufactures);
  yield put(manufacturesLoaded(result))
}

function* loadFeedbackTroubles() {
    const { result } = yield call(api.feedbackTroubles.feedbackTroubles);
    yield put(feedbackTroublesLoaded(result))
}

const loaderSettings = {
  streets: true,
  manufactures: true,
  vacancies: true,
  blockProducts: true,
};

function* loader(settings = loaderSettings) {
	settings = {...loaderSettings, ...settings};
	yield all(generateCalls(
    {
      loadManufactures: settings.manufactures,
      loadStreets: settings.streets,
      loadVacancies: settings.vacancies,
      loadBlockProducts: settings.blockProducts,
    },
    {
      loadStreets,
      loadManufactures,
      loadVacancies,
      loadBlockProducts,
    },
	))
}

export const catalogSaga = featureSagaCreator({
	init: loader,
	workers: function* () {
		yield all([
			takeEvery(LOAD_HOUSES, loadHouses),
            takeEvery(LOAD_FEEDBACK_TROUBLES, loadFeedbackTroubles),
		])
	},
});

